import { isFSA } from 'flux-standard-action'
import invariant from 'invariant'
import {
  TABLE_MANAGEMENT_REPORT_SET_LIST,
  TABLE_MANAGEMENT_REPORT_SET_SUMMARY,
  TABLE_MANAGEMENT_REPORT_SET_DETAIL,
  TABLE_MANAGEMENT_REPORT_OPEN_RIGHT_COLUMN,
  TABLE_MANAGEMENT_REPORT_CLOSE_RIGHT_COLUMN,
  TABLE_MANAGEMENT_REPORT_UNSET_FILTER_STATE,
  TABLE_MANAGEMENT_REPORT_SET_FILTER_STATE,
  TABLE_MANAGEMENT_REPORT_SET_CURRENT_PAGE,
  TABLE_MANAGEMENT_REPORT_SET_TOTAL_PAGE,
  TABLE_MANAGEMENT_REPORT_IS_SUBMITTING_FORM,
  TABLE_MANAGEMENT_REPORT_SET_MUST_SCROLL_TOP,
  TABLE_MANAGEMENT_REPORT_SET_IS_SUBMITTING_FORM
} from 'actions/tableManagement/constants'

let initialState = {
  reports: [],
  currentPage: null,
  totalPage: null,
  reportDetail: null,
  search: '',
  outlets: [],
  summary: {total_pages: 0, total_items: 0, completed: 0, cancelled: 0},
  filterState: {keyword: ''},
  openRightColumn: false,
  setting: {},
  mustScrollTop: false,
  isSubmittingForm: false
}

function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )
  let {payload} = action
  switch (action.type) {
    case TABLE_MANAGEMENT_REPORT_SET_LIST:
      return {...state, reports: payload.reports}
    case TABLE_MANAGEMENT_REPORT_SET_SUMMARY:
      return {...state, summary: payload.reportSummary}
    case TABLE_MANAGEMENT_REPORT_SET_DETAIL:
      return {...state, reportDetail: payload.report}
    case TABLE_MANAGEMENT_REPORT_OPEN_RIGHT_COLUMN:
      return {...state, openRightColumn: true}
    case TABLE_MANAGEMENT_REPORT_CLOSE_RIGHT_COLUMN:
      return {...state, openRightColumn: false}
    case TABLE_MANAGEMENT_REPORT_UNSET_FILTER_STATE:
      return {...state, filterState: {keyword: ''}}
    case TABLE_MANAGEMENT_REPORT_SET_FILTER_STATE:
      return {...state, filterState: {keyword: payload.keyword}}
    case TABLE_MANAGEMENT_REPORT_SET_TOTAL_PAGE:
      return {...state, totalPage: payload.totalPage}
    case TABLE_MANAGEMENT_REPORT_SET_CURRENT_PAGE:
      return {...state, currentPage: payload.currentPage}
    case TABLE_MANAGEMENT_REPORT_IS_SUBMITTING_FORM:
      return {...state, isSubmittingForm: payload.isSubmittingForm}
    case TABLE_MANAGEMENT_REPORT_SET_MUST_SCROLL_TOP:
      return {...state, mustScrollTop: payload.mustScrollTop}
    case TABLE_MANAGEMENT_REPORT_SET_IS_SUBMITTING_FORM:
      return {...state, isSubmittingForm: payload.isSubmittingForm}
    default:
      return {...state}
  }
}

export default reducer



// WEBPACK FOOTER //
// ./app/reducers/tableManagement/report.js